module.exports = __webpack_public_path__ + "static/media/polytope_3_3_5_cell600_layers_6_6.f15509e3.gif";